import type { ComponentProps } from 'react'

import { Box, Icon } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import getTitle from 'modules/documents/components/Documents/getTitle'
import { FoldersHeader } from 'modules/documents/components/Settings/FoldersHeader'
import { Folder } from 'modules/documents/hooks/useGetFolders'
import { SPACES } from 'modules/documents/lib/constants'

interface Props {
  folder?: Folder
  space: (typeof SPACES)[keyof typeof SPACES]
  openCreateModal: () => void
}

const headerData = (
  folder: Folder | undefined,
  space: (typeof SPACES)[keyof typeof SPACES]
): {
  title: string
  icon: ComponentProps<typeof Icon.Large>['icon']
  description?: string
} => {
  const icon = folder ? 'folder' : space === SPACES.COMPANY_PUBLIC ? 'folder-employee' : 'folder'

  const getDescription = () => {
    if (space === SPACES.COMPANY_INTERNAL) {
      return i18n.t('settings.folders.list.company.description')
    } else if (space === SPACES.COMPANY_PUBLIC) {
      return i18n.t('settings.folders.list.public_company.description')
    }
    return ''
  }

  const description = getDescription()

  const getFolderTitle = () => {
    if (folder) {
      return i18n.t('settings.folders.list.inside_folder.title', {
        folder_name: getTitle(folder.name),
      })
    }

    switch (space) {
      case SPACES.COMPANY_INTERNAL:
        return i18n.t('settings.folders.list.company.title_v2')
      case SPACES.COMPANY_PUBLIC:
        return i18n.t('settings.folders.list.public_company.title_v2')
      default:
        return i18n.t('settings.folders.list.employee.title_v2')
    }
  }

  return {
    title: getFolderTitle(),
    icon,
    ...(description && { description }),
  }
}

const TableHeader = ({ folder, space, openCreateModal }: Props) => {
  const { title, description } = headerData(folder, space)

  if (folder) return null

  return (
    <Box paddingTop="s24">
      <FoldersHeader
        title={title}
        description={description || ''}
        onCreateButton={openCreateModal}
        removePadding
      />
    </Box>
  )
}

export default TableHeader
